module.exports = __webpack_public_path__ + "img/qr_tutor_100.395c5cdf.png";